define(["./intlPhoneNumberModule"
], function (intlPhoneNumberModule) {
    "use strict";

    intlPhoneNumberModule.config(["ngIntlTelInputProvider", function (ngIntlTelInputProvider) {
        ngIntlTelInputProvider.set({
            onlyCountries: ["us", "br", "mx", "ar", "bo", "cl", "co", "ec", "pe", "py", "uy"],
            preferredCountries: [],
            autoPlaceholder: false,
        });
    }]);
});
